module.exports = __webpack_public_path__ + "static/media/PNImg5.7a20d130.webp";